
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { downloadPDF } from '@/utils/pdf.js'
import { postAudits } from '@/api/credit-note'
import dayjs from "dayjs";
@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isAnnual: boolean;
  @Prop({ default: "索赔维护" }) private title: "";
  // @Prop({ default: {} }) private selectedItem: {};
  @Prop({ default: {} as any }) private FAitem: any;
  @Prop({ default: {} as any }) private resTouch: any;

  @Prop({ default: 'CREDIT_NOTE' }) private tableNoteType: '';

  private topTable = {
    CnNumber: '',
    IssBY: '',
    AuthBY: '',
    IssDate: '',
  }

  public resList = [
    // 'The reason is for 2022 bonus amount and incentive amount, the details were confirmed by Michal Loyge and Peter Yin.',
    // 'MM Poland 2022 total invoices amount 1,000,000.66USD*2% =20,000.01USD',
    // 'MM Poland 2022 incentive amount 10,000USD',
    // 'MM Poland 2022 Marketing Support amount 10,000USD',
  ]

  private form = {
    CNAmount: '',
    type: ''
  } as any;
  private list = [
    {
      label: "CN金额",
      prop: "CNAmount",
      key: "CNAmount",
      type: "inputNumber",
      placeholder: "请输入CN金额",
      clearable: true,
      precision: 2,
      min: -9999999999,
      max: 9999999999,
      value: "",
      rules: {
        required: true,
        message: "请输入CN金额",
        trigger: "blur"
      },
    },
    {
      label: "币种",
      prop: "type",
      key: "type",
      type: "select",
      placeholder: "请选择币种",
      clearable: true,
      maxlength: 10,
      options: [{
        desc: "USD",
        name: "USD"
      },
      {
        desc: "EURO",
        name: "EURO"
      },
      {
        desc: "RMB",
        name: "RMB"
      }
      ],
      labelKey: "desc",
      valueKey: "name",
      rules: {
        required: true,
        message: "请选择币种",
        trigger: "blur"
      },
    }
  ];

  private oneReasonTop = '';
  private oneReasonBottom = '';
  private reasonInput = '';
  private ReasonStatus = false;

  mounted() {
    this.getAudits()
  }

  private cnCode = ''
  private cnAmount = ''
  private cnType = ''
  private IssBY = ''
  private IssDate = ''
  private ivCompanyName = ''
  private ivAddress = ''
  private nation = ''
  private ivOtherInfo = ''

  private async getAudits() {

    // CnNumber: '',
    // IssBY: '',
    // AuthBY: '',
    // IssDate: '',

    if(this.resTouch.creditNoteCode) {
      this.topTable.CnNumber = this.resTouch.creditNoteCode
    }
    if(this.resTouch.issuedBy) {
      this.topTable.IssBY = this.resTouch.issuedBy
    }
    if(this.resTouch.issuedDate) {
      this.topTable.IssDate = this.resTouch.issuedDate === undefined
        ? ""
        : this.parseDate(this.resTouch.issuedDate)
    }
    // if(this.resTouch.creditNoteAmount) {
    //   this.form.CNAmount = this.resTouch.creditNoteAmount
    // }
    this.form.CNAmount = this.resTouch.creditNoteAmount
    if(this.resTouch.currency) {
      this.form.type = this.resTouch.currency
    }
    if(this.resTouch.terms) {
      this.resList = this.resTouch.terms
      this.ReasonStatus = true
    }
    this.cnCode = this.resTouch.creditNoteCode
    this.cnAmount = this.resTouch.creditNoteAmount
    this.IssBY = this.resTouch.issuedBy
    this.IssDate === this.resTouch.issuedDate === undefined
        ? ""
        : this.parseDate(this.resTouch.issuedDate)
    this.cnType = this.resTouch.currency
    this.ivCompanyName = this.resTouch.ivCompanyName
    this.ivAddress = this.resTouch.ivAddress
    this.nation = this.resTouch.nation
    this.ivOtherInfo = this.resTouch.ivOtherInfo

    if(this.resList.length > 0) {
      if(this.resList[0].includes('the details were confirmed by')) {
        this.oneReasonTop =  this.resList[0].replace('the details were confirmed by','and').split('and')[0]
        this.oneReasonBottom = this.resList[0].replace('the details were confirmed by','and').split('and')[1]
      }
      if(this.resList[0].includes('The details were confirmed by')) {
        this.oneReasonBottom = this.resList[0].replace('The details were confirmed by','')
      }
    }

    this.resList = this.resList.map(item => {
      return {
        input: false,
        text: item
      }
    })
  }

  // public print: {
  //   id: 'adv1',
  //   popTitle: '产装联系单', // 打印配置页上方的标题
  //   extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
  //   preview: false, // 是否启动预览模式，默认是false
  //   previewTitle: '预览的标题', // 打印预览的标题
  //   previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
  //   zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
  //   previewBeforeOpenCallback() {
  //     console.log('正在加载预览窗口！')
  //   }, // 预览窗口打开之前的callback
  //   previewOpenCallback() {
  //     console.log('已经加载完预览窗口，预览打开了！')
  //   }, // 预览窗口打开时的callback
  //   beforeOpenCallback() {
  //     console.log('开始打印之前！')
  //   }, // 开始打印之前的callback
  //   openCallback() {
  //     console.log('执行打印了！')
  //   }, // 调用打印时的callback
  //   closeCallback() {
  //     console.log('关闭了打印工具！')
  //   }, // 关闭打印的callback(无法区分确认or取消)
  //   clickMounted() {
  //     console.log('点击v-print绑定的按钮了！')
  //   },
  //   // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
  //   // asyncUrl (reslove) {
  //   //   setTimeout(() => {
  //   //     reslove('http://localhost:8080/')
  //   //   }, 2000)
  //   // },
  //   standard: '',
  //   extarCss: '',
  // }

  created() {
    this.topTable.CnNumber = this.FAitem.code
  }

  private init() {
    this.topTable = {
      CnNumber: '',
      IssBY: '',
      AuthBY: '',
      IssDate: '',
    }
    this.form = {
      CNAmount: '',
      type: ''
    } as any;
    this.resList = []
    this.oneReasonTop = '';
    this.oneReasonBottom = '';
    this. reasonInput = '';
    this. ReasonStatus = false;
    this.cnCode = ''
    this.cnAmount = ''
    this.cnType = ''
    this.IssBY = ''
    this.IssDate = ''
    this.ivCompanyName = ''
    this.ivAddress = ''
    this.nation = ''
    this.ivOtherInfo = ''
  }

  private async handleExport() {
    let file_obj = await downloadPDF(
      this.$refs.pdf,
      {
        // scale: window.devicePixelRatio * 4,
        allowTaint: true,
        useCORS: true,
        scrollY: 0,
        scrollX: 0,
        removeContainer: true,
        onclone: true,
      },
      'CN.pdf'
    )
    console.log('file_obj',file_obj)
    this.downloadBlob(file_obj, 'CN.pdf')
    // await this.doUpload(file_obj)
    // this.$emit('handleExport1')
  }

  private downloadBlob(data, fileName) {
    // 1.解析 blob 数据 生成 url
    const blob = new Blob([data])
    const url = window.URL.createObjectURL(blob)
    // 2.创建下载链接+自动下载
    const link:any = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(link)
  }

  private handleClose() {
    this.$emit('handleClose')
    this.init()
  }

  private resListRemove(index) {
    this.resList.splice(index, 1)
    if(this.resList.length === 1) {
      this.resList[0].input = true
      this.resList[0].text = 'the details were confirmed by'
    }
  }

  private async resListAdd() {
    if (this.resList.length === 0) {
      this.resList.push({input: true, text: 'the details were confirmed by'})
    } else {
      if(this.resList.length === 1) {
        if(this.oneReasonBottom === '') {
          this.$notify({
            title: '提示',
            message: '请填写确认人',
            type: 'warning'
          })
          return
        }
        if (this.oneReasonTop === '') {
          this.resList[0].text = 'The details were confirmed by' + ' ' + this.oneReasonBottom
        } else {
          this.resList[0].text = this.oneReasonTop + ' ' + 'the details were confirmed by' + ' ' + this.oneReasonBottom
        }
        this.resList[0].input = false
        this.ReasonStatus = false
        this.resList.push({input: true, text: ''})
      } else {
        if (this.resList[this.resList.length-1].input) {
          this.resList[this.resList.length-1].input = false
          this.resList[this.resList.length-1].text = this.reasonInput
          this.reasonInput = ''
          this.ReasonStatus = false
          this.resList.push({input: true, text: ''})
        } else {
          this.reasonInput = ''
          this.ReasonStatus = false
          this.resList.push({input: true, text: ''})
        }
      }
    }
  }

  private async resListQueRen() {
    if (this.resList.length === 0) {
      this.$notify({
        title: '提示',
        message: '请填写条款',
        type: 'warning'
      })
    } else {
      if(this.resList.length === 1) {
        if(this.oneReasonBottom === '') {
          this.$notify({
            title: '提示',
            message: '请填写确认人',
            type: 'warning'
          })
          return
        }
        if (this.oneReasonTop === '') {
          this.resList[0].text = 'The details were confirmed by' + ' ' + this.oneReasonBottom
        } else {
          this.resList[0].text = this.oneReasonTop + ' ' + 'the details were confirmed by' + ' ' + this.oneReasonBottom
        }
        this.resList[0].input = false
        this.ReasonStatus = true
      } else {
        if (this.resList[this.resList.length-1].input) {
          this.resList[this.resList.length-1].input = false
          this.resList[this.resList.length-1].text = this.reasonInput
          this.reasonInput = ''
          this.ReasonStatus = true
        } else {
          this.ReasonStatus = true
        }
      }
    }
  }

  private async handleSubmit() {
    console.log(this.form.CNAmount);
    if(!this.ReasonStatus) {
      this.$notify({
        title: '提示',
        message: '请确认条款',
        type: 'warning'
      })
      return
    }
    if(this.resList.length === 0) {
      this.$notify({
        title: '提示',
        message: '请填写条款',
        type: 'warning'
      })
      return
    }
    if(this.form.CNAmount === '') {
      this.$notify({
        title: '提示',
        message: '请填写签发人',
        type: 'warning'
      })
      return
    }
    if(this.form.CNAmount === undefined || this.form.CNAmount === '') {
      this.$notify({
        title: '提示',
        message: '请填写CN金额',
        type: 'warning'
      });
      return;
    }
    if(Number(this.form.CNAmount) <= 0) {
      this.$notify({
        title: '提示',
        message: '请填写大于0CN金额',
        type: 'warning'
      });
      return;
    }
    if(this.form.type === '') {
      this.$notify({
        title: '提示',
        message: '请选择币种',
        type: 'warning'
      })
      return
    }
    if(this.topTable.IssBY === '') {
      this.$notify({
        title: '提示',
        message: '请填写签发人',
        type: 'warning'
      })
      return
    }
    if(this.topTable.IssDate === '') {
      this.$notify({
        title: '提示',
        message: '请填写签发日期',
        type: 'warning'
      })
      return
    }
    let data = {
      creditNoteAmount: this.form.CNAmount,
      currency: this.form.type,
      issuedBy: this.topTable.IssBY,
      issuedDate: this.topTable.IssDate === undefined
        ? ""
        : dayjs(this.topTable.IssDate).format("D[th] MMMM, YYYY"),
      // creditNoteRates: this.form.CNRate,
      terms: []
    }
    data.terms = this.resList.map(item => {
      return item.text
    })
    await postAudits(this.FAitem.id, data).then(res => {
      this.$emit('handleSuccess')
      this.init()
    }).catch(err => {
      console.log(err)
    })
  }

  private parseDate(dateString) {
    const parts = dateString.split(/[,\s]+/); // 分割日期字符串
    const month = { 'January': '01', 'February': '02', 'March': '03', 'April': '04', 'May': '05', 'June': '06', 'July': '07', 'August': '08', 'September': '09', 'October': '10', 'November': '11', 'December': '12' };
    const day = parts.splice(0, 2).join(' ');
    const thisDay = day.split(' ')[0].replace('th','')
    const thisMonth = day.split(' ')[1]
    return parts.pop() + '-' + month[thisMonth] + '-' + (Number(thisDay) > 10 ? thisDay : '0' + thisDay); // 返回字符串
  }

  private changeUpdate(e) {
    if(e.data.key === "type") {
      this.cnType = e.data.value
    }
  }

  // @Watch("show", { immediate: true })
  // private async watchData() {

  // }
}
